module.exports = __webpack_public_path__ + "static/media/exp_beach_3.740ff0c3.svg";